import styled from "styled-components";
import { SIZE } from "constants/variables";

export const OrganizeSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${SIZE.max65};

  @media (max-width: 768px) {
    row-gap: ${SIZE.max40};
  }
`;

export const OrganizeSectionTitleContainer = styled.div``;

export const OrganizeSectionTitleWrapper = styled.div``;

export const OrganizeSectionSubtitleWrapper = styled.div``;

export const OrganizeSectionCardsContainer = styled.div`
  display: flex;
  justify-content: center;
  column-gap: ${SIZE.max24};
  padding-inline: ${SIZE.max200};

  @media (max-width: 1024px) {
    padding-inline: ${SIZE.max24};
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: ${SIZE.max24};
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    padding-inline: 0;
    row-gap: ${SIZE.max10};
  }
`;

export const OrganizeSectionCardWrapper = styled.div`
  height: ${SIZE.max224};
  width: 100%;

  @media (max-width: 1024px) {
    height: ${SIZE.max260};
  }
  @media (max-width: 767px) {
    height: ${SIZE.max180};
    width: 100%;
  }
`;

export const OrganizeSectionContactCardWrapper = styled.div`
  height: ${SIZE.max224};

  @media (max-width: 1024px) {
    height: ${SIZE.max260};
  }

  @media (max-width: 767px) {
    height: ${SIZE.max120};
    width: 100%;
  }
`;
